export default __webpack_public_path__ + "static/media/coachingcallblob.30f014bd.svg";